<template>
  <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="500px" :close-on-click-modal="false">
    <el-form :model="form" :rules="rules" ref="form" label-width="100px">
      <el-form-item label="认领日期" prop="claimDate">
        <el-date-picker v-model="form.claimDate" type="date" placeholder="请选择认领日期" value-format="yyyy-MM-dd" style="width: 100%" />
      </el-form-item>
      <el-form-item label="认领人" prop="claimOperator">
        <el-select v-model="form.claimOperator" placeholder="请选择认领人" filterable clearable style="width: 100%;" :loading="employeeLoading" @focus="loadEmployeeList">
          <el-option v-for="employee in employeeList" :key="employee.employeePid" :label="employee.employeeName" :value="employee.employeeName" />
        </el-select>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">取 消</el-button>
      <el-button type="primary" :loading="loading" @click="handleSubmit">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { claimCustInfos, updateClaimInfo, queryEmployee } from '@/api/contract/contract'

export default {
  name: 'ClaimDialog',
  data () {
    return {
      dialogVisible: false,
      loading: false,
      mode: 'claim', // claim-认领, edit-修改认领日期
      selectedRows: [],
      employeeList: [],
      employeeLoading: false,
      form: {
        claimDate: '',
        claimOperator: ''
      },
      rules: {
        claimDate: [
          { required: true, message: '请选择认领日期', trigger: 'change' }
        ],
        claimOperator: [
          { required: true, message: '请选择认领人', trigger: 'change' }
        ]
      }
    }
  },
  computed: {
    dialogTitle () {
      return this.mode === 'claim' ? '认领确认' : '修改认领日期'
    }
  },
  methods: {
    /**
     * 获取当天日期，格式为 yyyy-MM-dd
     */
    getToday () {
      const d = new Date()
      const y = d.getFullYear()
      const m = String(d.getMonth() + 1).padStart(2, '0')
      const day = String(d.getDate()).padStart(2, '0')
      return `${y}-${m}-${day}`
    },
    /**
     * 获取当前登录用户名
     */
    getCurrentUserName () {
      // 优先从 Vuex store 获取
      if (this.$store && this.$store.state.loginUser && this.$store.state.loginUser.userName) {
        return this.$store.state.loginUser.userName
      }
      // 兜底从 localStorage 获取
      return localStorage.getItem('userName') || ''
    },
    show (rows, mode = 'claim') {
      this.selectedRows = rows
      this.mode = mode
      // 如果是修改模式，填充现有数据
      if (mode === 'edit' && rows.length === 1) {
        this.form.claimDate = rows[0].claimDate || ''
        this.form.claimOperator = rows[0].claimOperator || ''
      } else {
        // 认领模式：默认当天日期和当前操作人
        this.form.claimDate = this.getToday()
        this.form.claimOperator = this.getCurrentUserName()
      }
      this.dialogVisible = true
    },
    loadEmployeeList () {
      if (this.employeeList.length > 0 || this.employeeLoading) {
        return
      }
      this.employeeLoading = true
      const params = {
        pageSize: 200,
        curPage: 1
      }
      queryEmployee(params).then(res => {
        if (res.dataList) {
          this.employeeList = res.dataList || []
        } else {
          this.$message.error(res.retMsg || '获取职员列表失败')
          this.employeeList = []
        }
        this.employeeLoading = false
      }).catch(err => {
        this.$message.error('获取职员列表失败：' + (err.message || '网络错误'))
        this.employeeList = []
        this.employeeLoading = false
      })
    },
    handleSubmit () {
      this.$refs.form.validate(valid => {
        if (!valid) return

        this.loading = true
        const entrNums = this.selectedRows.map(row => row.entrustNum)
        const params = {
          entrNums: entrNums,
          claimDate: this.form.claimDate,
          claimOperator: this.form.claimOperator
        }

        const apiMethod = this.mode === 'claim' ? claimCustInfos : updateClaimInfo

        apiMethod(params).then(res => {
          this.loading = false
          if (res && res.retCode === 'ok') {
            this.$message.success(this.mode === 'claim' ? '认领成功' : '修改成功')
            this.dialogVisible = false
            this.$emit('refresh')
          } else {
            this.$message.error(res.retMsg || (this.mode === 'claim' ? '认领失败' : '修改失败'))
          }
        }).catch(err => {
          this.loading = false
          this.$message.error(err.message || (this.mode === 'claim' ? '认领失败' : '修改失败'))
        })
      })
    }
  }
}
</script>
